import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
// import "../Profile.css";


import {X} from 'lucide-react';

import LoadingButton from "../../../Loading/LoadingButton";
import CreateNewTopicPopUp from "./CreateNewTopicPopUp";
import { createNewMockTopic } from "../../../../store/actions/CreateContent/QuizAPI/createNewMockTest";
import QuizTopicCard from "./QuizTopicCard";
import QuizTopicCardLoading from "./QuizTopicCardLoading";
import Snackbar from "../../../../Snackbar";
import AreYouSurePopUp from "../ContentPopUp/AreYouSurePopUp";

 const SetTopicSidebar= ({currentIndex,itemQuestion,setCloseTopicSidebar,quizObject})=>{
    // const {category} = useParams();
   

    const App = useSelector((state)=>state?.app?.app);
     
    const dispatch = useDispatch();  
  
    const currentToken = useSelector((state)=>state?.user?.user?.token);
    const user_email = useSelector((state)=>state?.user?.user?.user_email
   );
   const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
   const appId = useSelector((state)=>state?.app?.app?.ID);
   const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
        
   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [closeNewTopicPopUp, setCloseNewTopicPopUp] = useState(false);
   
     const [snackbarColor, setSnackbarColor] = useState("#958FDA");
    const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
const [topicShow ,setTopicShow] =useState("currentTopic")
      const [itemArrLoading, setItemArrLoading] = useState([{},{}]);
     const [currentTopic, setCurrentTopic] = useState({});
     const [deleteTopicPopUp, setDeleteTopicPopUp] = useState(false);
      
     const [itemArr, setItemArr] = useState([]);
    const showSnackbar = () => {
     setSnackbarVisible(true);
   };
   
    const hideSnackbar = () => {
     setSnackbarVisible(false);
   };

       const [loader , setLoader] =useState({status:false});
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
          {
            
            dispatch({type: "CURSOR",payload:true  });
        
            dispatch({type: "CURSORTEXT",payload:CursorText})
            dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
            dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
          }
           
          const handleMouseLeave = () => {
            
            dispatch({type: "CURSOR",payload:false})
        
            dispatch({type: "CURSORTEXT",payload:""})
        
            dispatch({type: "CURSORTEXTBG",payload:""})
            dispatch({type: "CURSORTEXTCOLOR",payload:""})
          
        
        } 
    useEffect(()=>{fireGetMockTopicsByQuizId()},[closeNewTopicPopUp,deleteTopicPopUp,itemQuestion?.ID])
        
     const fireGetMockTopicsByQuizId=()=>{
       setItemArrLoading([{},{},{},{}])
        setLoader({status:true});
         
          const apiData = dispatch(createNewMockTopic({
            postParent:quizObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",visibility:"public",status:"active",
            editType:"getAll",appToken:AppToken,appId:appId}
            ));
          /* get response as Promise   */
          apiData.then(response => {
            if(response){   
              if(response?.topics){
                setItemArrLoading([])
            setResponseMessage(response?.message);
            setSnackbarColor("rgba(144, 202, 249,1)");
         setItemArr(response?.topics)
           }else{
            setResponseMessage("Something Went Wrong...");
              
            setSnackbarColor("#958FDA");
         
             
        setLoader({status:false});
        
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
         
           
        },3000)
           }
              
           
           if(response?.logout){
           
            setResponseMessage("You are Logged Out!!!");
              
            setSnackbarColor("#958FDA");
         
             
        setLoader({status:false});
        
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
         
           
        },3000)
            setTimeout(()=>{
              dispatch({type:"LOGOUT"});
        
            },3000)
            
          }
        /* resetting Login input Fields */
        
            }else{
              setResponseMessage("Something Went Wrong...");
              
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)    }
        
          }).catch(error => {
         
            //popup of error Info
            setResponseMessage("Something Went Wrong...");
              
            setSnackbarColor("#958FDA");
         
             
        setLoader({status:false});
        
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
         
           
        },3000)
            console.error(error);
          });
         
          }
          
      const handleDeleteTopicById=()=>{
         
         
         
         setLoader({status:true});
         
           const apiData = dispatch(createNewMockTopic({
                       postParent:quizObject?.ID,userEmail:user_email?user_email:"",
                       currentToken:currentToken?currentToken:"",topicId:currentTopic?.id,
                       editType:"delete",appToken:AppToken,appId:appId}
                       ));
           /* get response as Promise   */
           apiData.then(response => {
             if(response){  
             
            setTimeout(()=>{setDeleteTopicPopUp(false)},1000)
            if(response?.logout){
            
             setResponseMessage("You are Logged Out!!!");
               
             setSnackbarColor("#958FDA");
          
              
         setLoader({status:false});
         
         setSnackbarVisible(true);
         setTimeout(()=>{
           
           setSnackbarVisible(false);
          
            
         },3000)
             setTimeout(()=>{
               dispatch({type:"LOGOUT"});
         
             },3000)
             
           }
         /* resetting Login input Fields */
         
             }else{
               setResponseMessage("Something Went Wrong...");
               
               setSnackbarColor("#958FDA");
            
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
              
           },3000)    }
         
           }).catch(error => {
          
             //popup of error Info
             setResponseMessage("Something Went Wrong...");
               
             setSnackbarColor("#958FDA");
          
              
         setLoader({status:false});
         
         setSnackbarVisible(true);
         setTimeout(()=>{
           
           setSnackbarVisible(false);
          
            
         },3000)
             console.error(error);
           });
          
           }
    const flattenedData = itemArr!=[]?Object.values(itemArr):'';

  const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';

       return <>
         
 <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{zIndex:99,cursor:"pointer"}} onClick={()=>setCloseTopicSidebar(false)} className="appDesignPopUpOpacity"> </div>
        <div   className="QueOptionPopUp" style={{borderRadius: '20px',zIndex:"9999999",}}> 
        {closeNewTopicPopUp?<CreateNewTopicPopUp
         quizObject={quizObject} menuOrder={itemArr?.length+1}
         currentTopic={currentTopic}
         returnTopicObject={(val)=>{
         setItemArr({...itemArr,val})
        }} setCloseNewTopicPopUp={()=>{setCloseNewTopicPopUp(false)}} />:""}
        
        {deleteTopicPopUp?<AreYouSurePopUp loadingText="Deleting..."  title="Delete This Topic" type="deleteTopic"
 closePopUp={()=>{setDeleteTopicPopUp(false)}}
 onClickPopup={(type)=>{handleDeleteTopicById();
  }}/>:""}
   <h2 align="center" >  Link Question To <span className="coloredTextV1" > Topic</span> </h2>
      
 {/* <div style={{width:"240px",display:"flex",justifyContent:"space-around",gap:"10px",margin:"10px"}}>    <div style={{border:topicShow=="currentTopic"?"3px solid #ffffff":"3px solid  rgba(144, 202, 249,1)",width:"120px",color:topicShow=="currentTopic"?"#ffffff":"#222222",background:topicShow=="currentTopic"?"rgba(144, 202, 249,1)":"#ffffff",borderRadius:"15px",fontSize:"13px",
                  fontWeight:"bold",padding:"8px",paddingTop:"10px",height:"15px",cursor:"pointer" , display:"flex",justifyContent:"center",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                  onClick={()=>{setTopicShow("currentTopic")}}
                   onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave}  
                  > Selected Topic</div>
                   <div style={{border:topicShow=="allTopics"?"3px solid #ffffff":"3px solid rgba(144, 202, 249,1)",width:"120px",color:topicShow=="allTopics"?"#ffffff":"#222222",background:topicShow=="allTopics"?"rgba(144, 202, 249,1)":"#ffffff",borderRadius:"15px",fontSize:"13px",
                  fontWeight:"bold",padding:"8px",paddingTop:"10px",height:"15px",cursor:"pointer" ,display:"flex",justifyContent:"center", boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                  onClick={()=>{setTopicShow("allTopics")}}
                   onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                  > All Topics</div> </div> */}
<div className="optionPopUpScroll" >
<div style={{margin:"5px",marginTop:"0px",padding:"0px",background:"#ffffff",borderRadius:"10px",overflow:"hidden",}}>
            <div style={{display:"flex",justifyContent:"space-between",gap:"20px"}}>  <div  style={{height:"19.2px",
            zIndex:"9", top:"0px",maxWidth:"180px"}} 
          className="product-tag-theme1 TitleWithEllipsis">  <div  
          color="#666666" align="center" style={{padding:"4px",float:"left",width:"10px",height:"10px",
          background:"#ffffff",color:"#222",borderRadius:"15px",cursor:"pointer",cursor: 'move',marginRight:"10px"}}>
            {currentIndex}</div>{itemQuestion?.queType} </div>
        </div>
<div  style={{margin:"0px",marginTop:"0px",padding:"10px",paddingLeft:"10px",background:"#ffffff"}} >

      
 <div  style={{display:"flex",justifyContent:"space-between"}}> <div className=" "
 style={{fontSize:"15px",color:"#111",fontWeight:"700" ,}}> 
 Q{currentIndex}: {itemQuestion?.queName}
   
      </div></div>
      <div  className=""
         style={{fontSize:"10px",color:"#222",display:"flex",justifyContent:"space-around",fontWeight:"800"}}>
         
         </div>
        
 </div> </div>
    <div className="" style={{paddingBottom:"50px"}}>
    
  {flattenedDataLoading?flattenedDataLoading?.map((item, index) => (
  <QuizTopicCardLoading  /> )):""} 
     {flattenedDataLoading?.length==0?flattenedData?.length?flattenedData?.map((item, index) => 
        (<div  index={index} key={item?.id}  style={{}}  >
<QuizTopicCard topic_name={item?.topic_name}
    topic_description={item?.topic_description}
    difficulty_level={item?.difficulty_level}
      setCurrentTopic={(ob)=> {setCurrentTopic(ob);;setCloseNewTopicPopUp(true)}} 
      item={item} deleteCurrentTopic={(ob)=> {setCurrentTopic(ob);setDeleteTopicPopUp(true)}}
      questionId={itemQuestion?.ID}
     />

 </div>)):"":""}





</div>

<div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"0px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{setCloseTopicSidebar(false)}}   className=" CoursesPreviewTopBtn"  type="submit" style={{background:"#222222",color:"#fff",}}
 > Cancel </button>
<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{setCloseNewTopicPopUp(true);setCurrentTopic({})}}
  style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > Add New Topic </button>
</div> 
</div>

     </div>

       <div>
     </div>

     
     </>


}
export default SetTopicSidebar;